import { httpFetch } from '../Utils/httpUtils'
import { bankruptcyTerminationActionTypes as actionTypes } from '../ActionTypes/bankruptcyTerminationActionTypes'

const bankruptcyTerminationActions = {

    getJobs(page, pageSize) {
        return (dispatch) => {
            return httpFetch(`/api/BankruptcyTermination/GetJobs?page=${page}&pageSize=${pageSize}`, dispatch)
                .then(json => {
                    dispatch({ type: actionTypes.STORE_BANKRUPTCY_JOBS, data: json });
                })
        }
    },

    getJobDetail(jobId, page, pageSize) {
        return (dispatch) => {
            return httpFetch(`/api/BankruptcyTermination/GetJobDetails/${jobId}?page=${page}&pageSize=${pageSize}`, dispatch)
                .then(json => {
                    dispatch({ type: actionTypes.STORE_BANKRUPTCY_JOB_DETAIL, data: json });
                })
        }
    },

    setManuallyHandled(customerResultId, value) {
        return (dispatch) => {
            dispatch({ type: actionTypes.SET_MANUALLY_HANDLED, customerResultId, value });
            return httpFetch(`/api/BankruptcyTermination/UpdateManuallyHandled/customer/${customerResultId}/manually-handled`, dispatch, {
                method: 'PATCH',
                body: JSON.stringify(value)
            });
        }
    }
}

export default bankruptcyTerminationActions
